<div class="dialog-container">
    <div class="dialog-header">
        <div class="left-section">
            <div class="heading">
                {{'changePassword' | translate}}
            </div>
        </div>
        <div class="right-section">
            <div class="close-icon">
                <app-icon path="assets/images/common/cross-icon.svg" (click)="onClose()"></app-icon>
            </div>
        </div>
    </div>

    <div class="dialog-content">
        <form [formGroup]="form" autoFocus (ngSubmit)="onSubmit()">
            <div class="fields-wrapper">
                <div class="input-field">
                    <label for="">{{'oldPassword' | translate}}</label>
                    <div class="field-wrap">
                        <div class="field">
                            <input [type]="viewPassword.oldPassword ? 'text' : 'password'" formControlName="oldPassword">
                            <span (click)="toggleViewPassword('oldPassword')">
                                @if (viewPassword.oldPassword) {
                                <app-icon path="assets/images/common/eye-slash.svg" />
                                } @else {
                                <app-icon path="assets/images/common/eye.svg" />
                                }
                            </span>
                        </div>
                        <app-form-error-message [form]="form" controlName="oldPassword" />
                    </div>
                </div>
                <div class="input-field">
                    <label for="">{{'newPassword' | translate}}</label>
                    <div class="field-wrap">
                        <div class="field">
                            <input [type]="viewPassword.newPassword ? 'text' : 'password'" formControlName="newPassword">
                            <span (click)="toggleViewPassword('newPassword')">
                                @if (viewPassword.newPassword) {
                                <app-icon path="assets/images/common/eye-slash.svg" />
                                } @else {
                                <app-icon path="assets/images/common/eye.svg" />
                                }
                            </span>
                        </div>
                        <app-form-error-message [form]="form" controlName="newPassword" />
                    </div>
                </div>
                <div class="input-field">
                    <label for="">{{'confirmPassword' | translate}}</label>
                    <div class="field-wrap">
                        <div class="field">
                            <input [type]="viewPassword.confirmPassword ? 'text' : 'password'" formControlName="confirmPassword">
                            <span (click)="toggleViewPassword('confirmPassword')">
                                @if (viewPassword.confirmPassword) {
                                <app-icon path="assets/images/common/eye-slash.svg" />
                                } @else {
                                <app-icon path="assets/images/common/eye.svg" />
                                }
                            </span>
                        </div>
                        <app-form-error-message [form]="form" controlName="confirmPassword" />
                    </div>
                </div>
            </div>
            <div class="submit-button">
                <button class="rounded-btn primary-gradient">{{'changePassword' | translate}}</button>
            </div>
        </form>
    </div>
</div>